import { Observable } from 'rxjs';
import { ContactFormInformationResponse } from '../models/ContactFormInformationResponse-response.model';
import { ContactFormRequest } from '../models/ContactFormRequest.model';
import { ContactFormResponse } from '../models/ContactFormResponse.model';

export abstract class CustomerSupportRepository {
    abstract sendForm(
        sendFormRequest: ContactFormRequest,
    ): Observable<ContactFormResponse>;
    abstract getContactFormInformation(): Observable<ContactFormInformationResponse>;
}
